import React, { PropTypes, Component } from 'react';
import classNames from 'classnames';
import Tag from './Tag';
import { Units } from 'Css';

const css = oxygenCss({
  tagsContainer: {
    display: 'inline-block',
    padding: `${Units.base / 2}px 0`,
    '&fullWidth': {
      display: 'block'
    }
  }
});

export default class TagList extends Component {
  static propTypes = {
    tags: PropTypes.object,
    fullWidth: PropTypes.bool
  };

  static defaultProps = {
    fullWidth: false
  };

  addedTags = [];

  render() {
    const { tags, fullWidth, ...other } = this.props;
    const classes = classNames(css.tagsContainer, {
      [css.fullWidth]: fullWidth
    });
    return (
      <div className={classes}>
        {tags &&
          Object.keys(tags).map(tagName => {
            if (tags[tagName]) {
              return (
                <Tag
                  {...other}
                  onRemove={this.removeTag}
                  key={tagName}
                  tag={tagName}
                />
              );
            }
            return null;
          })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Tags/TagList.js